<div>
    <mat-card oneCard class="cf-one-card">
        <mat-card-title>
            <span style = "margin-bottom: 0px;" mat-dialog-title class="mat-title">{{ data.title }}</span>
        </mat-card-title>
        <div mat-dialog-content>
            {{ data.message }}
        </div>
        <div mat-dialog-actions align="end">
            <button  [mat-dialog-close]="true" color="primary" mat-flat-button>
                {{ data.confirmButtonText || 'Accept' }}
            </button>
        </div>
    </mat-card>
</div>
